module.exports = __webpack_public_path__ + "img/czf_img@2x.a93cb1c3.png";